<template>
    <v-container>
        <v-form ref="form">
            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Din mail"
                required
            ></v-text-field>

            <v-text-field
                v-model="password"
                type="password"
                :rules="passRules"
                label="Lösenord"
                required
            ></v-text-field>
            <v-row>
                <a @click="$router.replace('/resetpassword')">Glömt lösenord?</a>
            </v-row>
            <v-btn
                    style="background-color:#ffa500;width:200px"
                    class="mr-4"
                    v-on:click="submit"
                    :loading="loading"
                    v-show="!createmeeting"
                >
                    Logga in
                    <v-icon style="font-size:13px;margin-left:6px;"
                        >fas fa-check</v-icon
                    >
                </v-btn>

                <router-link to="/register">
                    <v-btn v-show="!createmeeting" color="success" style="margin-top:6px;width:200px" class="mr-4 ">
                        Registrera dig
                        <v-icon style="font-size:13px;margin-left:6px"
                            >fas fa-edit</v-icon
                        >
                    </v-btn>
                </router-link>
        </v-form>
        <v-dialog v-model="loading" fullscreen>
            <v-container
                fluid
                fill-height
                style="background-color: rgba(255, 255, 255, 0.5);"
            >
                <v-layout justify-center align-center>
                    <v-progress-circular indeterminate color="primary">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-dialog>
    </v-container>
</template>

<script>
import store from "../../../store";
export default {
    store: store,
    name: "Login",
    props: ["createmeeting"],
    created: function() {
        if (this.$store.state.isLoggedIn && !this.createmeeting)
            this.$router.replace("/dashboard");
    },
    data: () => ({
        loading: false,
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ],
        select: null,
        password: "",
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste vara större än 8 tecken"
        ]
    }),
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async submit() {
            this.loading = true;
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("email", this.email);
            bodyFormData.set("password", this.password);
            const config = {
                method: "post",
                url: "",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            

            if (this.$refs.form.validate()) {
                await this.$store
                    .dispatch("login", config)
                    .then(() => (this.loading = false))
                this.loading = false;
                if (this.createmeeting) this.loading= false;
                else this.$router.replace("/admin/dashboard");
            } else {
                this.store.state.showAlert=true;
                this.store.state.alertMsg = "Please Fill Appropreate Data";
                this.store.state.alertType = "error"
            }
        }
    }
};
</script>
